<template></template>
<script>
export default {
	created() {
		this.$router.replace('/admin')
	}
}
</script>
<style lang="scss" scoped></style>
